module.exports = __webpack_public_path__ + "img/ready-tip@2x.ac81bfdb.png";